import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@store/utils';

export interface Policies {
  plan_number: number;
  first_name: string;
  last_name: string;
  email: string;
  business_name: string;
  created_at: string;
  paid_at: string | null;
  expiration_date: string | null;
  status: string;
  current_premium: number;
  paid_premium_ytd: number;
  total_premium: number;
  total_paid_premium: number;
  commission_earned_ytd: number;
  total_commission: number;
}

export const policiesApi = createApi({
  reducerPath: 'policies/',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getMyPolicies: builder.query<any, any>({
      query: () => ({
        url: `my_policies/`,
      }),
    }),
    getPoliciesInfo: builder.query<
      any,
      { public_id: string; secret_link: string }
    >({
      query: ({ public_id, secret_link }) => ({
        url: `policies/${public_id}-${secret_link}`,
      }),
    }),
    getMyProperties: builder.query<any, any>({
      query: () => ({
        url: `my_properties/`,
      }),
    }),
  }),
});

export const {
  useGetMyPoliciesQuery,
  useGetPoliciesInfoQuery,
  useGetMyPropertiesQuery,
} = policiesApi;
